import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {getScriptSettings} from '../../common/settings';

import {container, consentBar, consentCopy, buttonContainer, primaryBtn} from './consentBar.module.scss';

import './consentBar.scss';

/**
 * Helper function for pushing an action onto the Tracker Data Layer.
 * @param {TrackerDataLayer~TrackersCallback} callback
 */
export function trackersPush(callback) {
  const {settings: {trackersDataLayerName = 'trackersJsDataLayer'} } = getScriptSettings();

  window[trackersDataLayerName] = window[trackersDataLayerName] || [];
  window[trackersDataLayerName].push(callback);
}

function handleConsent(onConsented) {
  if (onConsented) {
    onConsented(true);
    trackersPush(trackers => {
      trackers.action('ccpa-consent-click');
    });
  }
  $('#attentive_overlay').removeClass('shifted').addClass('unshift');
}

export default function CCPAConsentBar({onConsented, skipMainContentLink}) {
  const [responded, setResponded] = useState(false);

  const handleClick = useCallback(() => {
    setResponded(true);
    handleConsent(onConsented);
  });

  const handleKeyPress = useCallback(() => {
    setResponded(true);
    handleConsent(onConsented);
    // Set focus to skip to main content link.
    if (typeof skipMainContentLink !== 'undefined') {
      skipMainContentLink.focus();
    }
  });

  useEffect(() => {
    function callback(mutationList, observer) {
      mutationList.forEach(mutation => {
        switch (mutation.type) {
          case 'childList': {
            mutation.addedNodes.forEach(node => {
              if (node.id === 'attentive_overlay') {
                setTimeout(() => {
                  $(node).addClass('shifted');
                }, 500);
                observer.disconnect();
              }
            });
            break;
          }
          default:
            break;
        }
      });
    }

    const target = document.body;
    const observerOptions = {
      childList: true,
      subtree: false,
    };

    const observer = new MutationObserver(callback);
    observer.observe(target, observerOptions);

    return () => {
      observer.disconnect();
    };
  }, []);

  if (responded) {
    return null;
  }

  // eslint-disable-next-line max-len
  return <div className={`bt-consent-bar ${container}`} id="bt-consent-bar-container" tabIndex="-1" role="complementary" aria-label="CCPA consent">
    <div className={`bt-consent-bar ${consentBar}`}>
      <div className={`bt-consent-bar ${consentCopy}`}>
        <p>
        This site uses cookies to provide you with a better browsing experience and relevant advertising.
        Further information may be found in the <a
            className='bt-consent-bar'
            rel={'noreferrer'}
            target={'_blank'} href={'https://www.biotrust.com/pages/privacy-policy'}>
            BioTrust Site Privacy Policy
          </a>.
        </p>
      </div>
      <div className={`bt-consent-bar ${buttonContainer}`} id="bt-consent-button-container">
        {/* eslint-disable-next-line max-len */}
        <span className={`bt-consent-bar ${primaryBtn}`} onClick={handleClick} onKeyPress={handleKeyPress} tabIndex="0" role="button">OK</span>
      </div>
    </div>
  </div>;
}

// eslint-disable-next-line max-len
CCPAConsentBar.propTypes = {onConsented: PropTypes.func, skipMainContentLink: PropTypes.object};
